<style>
  .home {
    text-align: center;
    margin-top: 45px;
    padding: 0.5rem 1rem;
  }
</style>

<template>
  <div class="home">
    <ViewSummary title="Un Sueño Hecho Realidad" name="novias"
     description="Vestidos de novia realizados para cada sueño, para cada mujer, donde definir la silueta,
      el estilo, el momento. Nos lleva a crear un vestido único, especial.
      Desde gasas lánguidas, tules, delicados encajes, hasta los mas sofisticados diseños en los
      tejidos mas especiales. Cuidados detalles que harán que tu vestido sea una pieza única.
      Crear un vestido de novia se trata de eso… de soñar."
     url="/novias"
     :image="{
        default: 'https://cdn.nohaypuntadasinhilo.com/n1_L.webp',
        sources: [
          {src: 'https://cdn.nohaypuntadasinhilo.com/n1_S.webp', media: '(max-width: 600px)'},
          {src: 'https://cdn.nohaypuntadasinhilo.com/n1_M.webp', media: '(max-width: 800px)'},
        ]
    }"/>
    <ViewSummary title="Preparate Para Cualquier Evento" name="fiesta"
     description="Acudir a una boda, fiesta, cóctel… siempre queremos sentirnos perfectas, cómodas..
      sin tener que renunciar al estilo.
      Por eso una prenda creada para ti, a tu medida , con los tejidos y complementos más diversos
      Son la solución perfecta."
     url="/fiesta"
     image-reverse
     :image="{
        default: 'https://cdn.nohaypuntadasinhilo.com/f1_L.webp',
        sources: [
          {src: 'https://cdn.nohaypuntadasinhilo.com/f1_S.webp', media: '(max-width: 600px)'},
          {src: 'https://cdn.nohaypuntadasinhilo.com/f1_M.webp', media: '(max-width: 800px)'},
        ]
    }"/>
    <ViewSummary title="Marca la diferencia" name="complementos"
     description="Si un vestido es importante, No lo es menos un complemento adecuado.
      Desde una diadema, cinturón, bolso... Cualquier detalle puede hacer resaltar tu look. ¡MARCA LA DIFERENCIA!"
     url="/complementos"
     :image="{
        default: 'https://cdn.nohaypuntadasinhilo.com/c1_L.webp',
        sources: [
          {src: 'https://cdn.nohaypuntadasinhilo.com/c1_S.webp', media: '(max-width: 600px)'},
          {src: 'https://cdn.nohaypuntadasinhilo.com/c1_M.webp', media: '(max-width: 800px)'},
        ]
    }"/>
  </div>
</template>

<script>
// @ is an alias to /src
import ViewSummary from '@/components/ViewSummary.vue'

export default {
  name: 'home',
  components: {
    ViewSummary
  }
}
</script>
